import {lazy, filter, trigger} from './lang.js';

export const graphic = (type, ...g_args) => {
    return (...args) => {
        let [stepData, stepNumber, time] = args;
        
        if (!stepData) {
            return filter(false);
        }
        let _type = lazy(type, ...args);
        let _g_args = g_args.map(
            arg => lazy(arg, ...args));
        return trigger({
            stepData, 
            stepNumber, 
            time, 
            graphics: {
                type: _type,
                arg: _g_args
            }
        });
    };
};

export const draw = (...args) => {
    return graphic(
        'DRAW',
        ...args);
};

export const erase = (position) => {
    return graphic(
        'ERASE',
        position
    );
};

export const flip = (position) => {
    return graphic(
        'FLIP',
        position
    );
};
